import { render, staticRenderFns } from "./RibbonAnimation.pug?vue&type=template&id=637e6130&scoped=true&lang=pug&"
import script from "./RibbonAnimation.vue?vue&type=script&lang=js&"
export * from "./RibbonAnimation.vue?vue&type=script&lang=js&"
import style0 from "./RibbonAnimation.scss?vue&type=style&index=0&id=637e6130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e6130",
  null
  
)

export default component.exports